var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlarm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#1B1D1E",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.057.91l-.905.425A13.051 13.051 0 00.747 6.06l-.543.84 1.68 1.086.542-.84a11.051 11.051 0 014.576-4l.905-.425-.85-1.81zm10.79.45l-.904-.425-.85 1.81.905.425a11.05 11.05 0 014.576 4l.543.84 1.68-1.085-.544-.84a13.05 13.05 0 00-5.405-4.725zM12.01 3.594c-5.368 0-9.778 4.214-9.778 9.483 0 2.65 1.115 5.033 2.907 6.748l-1.823 1.823 1.414 1.415 2.002-2.003c1.526.95 3.34 1.5 5.278 1.5a9.97 9.97 0 005.033-1.352l1.881 1.882 1.414-1.414-1.661-1.662c1.91-1.726 3.111-4.188 3.111-6.937 0-5.27-4.41-9.483-9.778-9.483zm-7.778 9.483c0-4.101 3.45-7.483 7.778-7.483 4.328 0 7.778 3.382 7.778 7.483 0 4.1-3.45 7.483-7.778 7.483-4.328 0-7.778-3.382-7.778-7.483zm8.556-.973v-4.17h-2v7.864l5.784-3.776-1.093-1.675-2.69 1.757z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarm);
export default __webpack_public_path__ + "static/media/alarm.c07de31f.svg";
export { ForwardRef as ReactComponent };